import script from "./Case2.vue?vue&type=script&setup=true&lang=js"
export * from "./Case2.vue?vue&type=script&setup=true&lang=js"

import "./Case2.vue?vue&type=style&index=0&id=1855a5f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1855a5f2"]])

export default __exports__